<div class="set-order-container">
  <h2>Cambiar orden</h2>

  <div class="info-match">
    <div><strong>{{player1Name}}</strong> vs <strong>{{player2Name}}</strong></div>
    <div>Categoría: <strong>{{match.category}}</strong></div>
    <div>Posición actual: <strong>#{{currentPosition}}</strong> de {{maxPosition}}</div>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field appearance="fill">
      <mat-label>Nueva posición</mat-label>
      <input matInput type="number" formControlName="position" [min]="1" [max]="maxPosition" />
      <mat-hint>Entre 1 y {{maxPosition}}</mat-hint>
    </mat-form-field>

    <div class="quick-buttons">
      <button type="button" class="quick" (click)="setQuick(1)">#1</button>
      <button type="button" class="quick" (click)="setQuick(2)">#2</button>
      <button type="button" class="quick" (click)="setQuick(3)">#3</button>
      <button type="button" class="quick" (click)="setQuick(currentPosition - 1)"
              [disabled]="currentPosition <= 1">−1</button>
      <button type="button" class="quick" (click)="setQuick(currentPosition + 1)"
              [disabled]="currentPosition >= maxPosition">+1</button>
      <button type="button" class="quick" (click)="setQuick(maxPosition)">Último</button>
    </div>

    <div class="buttons">
      <button mat-flat-button type="submit" [disabled]="form.invalid" color="primary">
        Aplicar
      </button>
      <button mat-stroked-button type="button" (click)="cancel()">Cancelar</button>
    </div>
  </form>
</div>
